import React, { useEffect, useState } from 'react';
import { useNotification } from '../../../../context/NotificationContext';
import {
  DEFAULT_CONTROL_PANEL_NAME,
  useControlPanelBranding,
} from '../../../context/control-panel/ControlPanelBrandingContext';
import { setControlPanelName } from './controlPanelNameApi';

const ControlPanelNameCard = () => {
  const { showToast } = useNotification();
  const { name } = useControlPanelBranding();
  const [draft, setDraft] = useState(name);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setDraft(name);
  }, [name]);

  const trimmed = draft.trim();
  const canSave = trimmed.length > 0 && trimmed !== name && !saving;

  const handleSave = async (e) => {
    e?.preventDefault();
    if (!trimmed) {
      setError('Enter a control panel name.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      await setControlPanelName(trimmed);
      showToast('Control panel name updated.', 'success');
    } catch (err) {
      const message = err?.message || 'Failed to save control panel name';
      setError(message);
      showToast(message, 'error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <section className="admin-card app-settings-card platform-credentials-card">
      <div className="platform-credentials-card__header">
        <div>
          <h2 className="platform-credentials-card__title">Control panel</h2>
          <p className="platform-credentials-card__desc">
            Name shown in the sidebar, browser tab, and admin invite screens.
          </p>
        </div>
      </div>

      {error && (
        <div className="pkg-dialog-alert pkg-dialog-alert--error" role="alert">
          {error}
        </div>
      )}

      <form className="platform-credentials-form" onSubmit={handleSave}>
        <div className="pkg-dialog-field">
          <label htmlFor="control-panel-name">Name</label>
          <input
            id="control-panel-name"
            className="pkg-dialog-input"
            type="text"
            value={draft}
            onChange={(e) => {
              setDraft(e.target.value);
              setError('');
            }}
            placeholder={DEFAULT_CONTROL_PANEL_NAME}
            maxLength={80}
            autoComplete="off"
          />
        </div>
        <div className="platform-credentials-actions">
          <button type="submit" className="pkg-btn pkg-btn-primary" disabled={!canSave}>
            {saving ? 'Saving…' : 'Save name'}
          </button>
        </div>
      </form>
    </section>
  );
};

export default ControlPanelNameCard;
